/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { stringify } from 'query-string';
import { LOGO_SMALL_URL, getApiUrl } from '~services/utils'; // eslint-disable-line

// Messages
import messages from './messages/Navigation_messages';

// Styles
import './styles/Navigation.scss';

// Components
import LocaleFlag from './LocaleFlag';
import UserNavItem from '../user/UserNavItem';

const propTypes = {
  locale: PropTypes.object.isRequired,
  changeLocale: PropTypes.func.isRequired,
  // logout: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

class Navigation extends PureComponent {
  state = {
    hideDropdown: true,
    flagConfig: {
      fi: {
        flagCode: 'fi',
        langCode: 'fi',
        langName: 'Suomi',
      },
      sv: {
        flagCode: 'se',
        langCode: 'sv',
        langName: 'Svenska',
      },
      en: {
        flagCode: 'gb',
        langCode: 'en',
        langName: 'English',
      },
    },
  };

  _changeLocale = action => {
    this.setState({ hideDropdown: true });
    this.props.changeLocale(action);
  };

  _toggleDropdown = () => {
    this.setState({ hideDropdown: !this.state.hideDropdown });
  };

  render() {
    const { session, history, locale, intl } = this.props;
    const { flagConfig } = this.state;

    const tvLogin = session.logins.tilaajavastuu;
    const dashboardUrl = tvLogin
      ? `/selvitys/${tvLogin.client.company.country}/` +
        `${tvLogin.client.company.identifier}/dashboard`
      : '';

    const navigateToDashboard = () => history.push(dashboardUrl);
    const userNavItemProps = {
      user: tvLogin ? tvLogin.client : null,
      history,
      actions: [
        {
          label: intl.formatMessage(messages.logout),
          action: () => { window.location.href = '/api/authenticate/logout'; },
        },
        {
          label: intl.formatMessage(messages.controlPanel),
          action: navigateToDashboard,
        },
      ],
    };

    const dropdown = classNames('actions-dropdown', {
      hidden: !!this.state.hideDropdown,
    });

    const searchLinksByLocale = {
      fi: '/haku',
      en: '/search-company',
      sv: '/sok-foretag',
    };

    const tosLinksByLocale = {
      fi: '/zeckit-palvelun-kayttoehdot',
      en: '/zeckit-palvelun-kayttoehdot',
      sv: '/zeckit-palvelun-kayttoehdot',
    };

    const tutorialLinksByLocale = {
      fi: '/mika-zeckit/mika-zeckit-selvitys',
      en: '/mika-zeckit/mika-zeckit-selvitys',
      sv: '/vad-ar-zeckit/utdrag',
    };

    const instructionLinksByLocale = {
      fi: '/yritystietojen-muokkaus',
      en: '/amend-company-information',
      sv: '/andra-foretagsinformation',
    };

    const loginParams = { locale: locale.lang };

    return (
      <nav styleName="Navigation">
        <div styleName="navigation-wrapper">
          <a styleName="navigation-logo" href="https://zeckit.com">
            <img alt="Zeckit logo" src={LOGO_SMALL_URL} />
          </a>

          <ul styleName="navigation-links bottom-level">
            <li styleName="navigation-link">
              <a href={searchLinksByLocale[locale.lang]}>
                <FormattedMessage
                  {...messages.searchCompanies}
                  info="Search for other companies"
                />
              </a>
            </li>

            <li styleName="navigation-link">
              <a href={tosLinksByLocale[locale.lang]}>
                <FormattedMessage {...messages.tos} info="Terms of service" />
              </a>
            </li>

            <li styleName="navigation-link">
              <a href={tutorialLinksByLocale[locale.lang]}>
                <FormattedMessage
                  {...messages.about}
                  info="About the report"
                />
              </a>
            </li>
          </ul>

          <ul styleName="navigation-links top-level">
            {!tvLogin && (
              <li styleName="navigation-link">
                <a
                  href={
                    `${getApiUrl()}/authenticate/login?${
                      stringify(loginParams)
                    }`
                  }
                >
                  <FormattedMessage {...messages.login} info="Login" />
                </a>
              </li>
            )}

            {tvLogin && (
              <li styleName="navigation-link  company-user">
                <UserNavItem {...userNavItemProps} />
              </li>
            )}
            <li styleName="navigation-link">
              <a href={instructionLinksByLocale[locale.lang]}>
                <FormattedMessage
                  {...messages.companyInstructions}
                  info="Login"
                />
              </a>
            </li>

            <li styleName="navigation-link">
              <div styleName="locale-dropdown">
                <div onClick={this._toggleDropdown}>
                  <LocaleFlag
                    lang={flagConfig[locale.lang].langCode}
                    flag={flagConfig[locale.lang].flagCode}
                    langName={flagConfig[locale.lang].langName}
                    selectedLocale={
                      locale.lang === flagConfig[locale.lang].langCode
                    }
                  />
                </div>

                <div styleName={dropdown}>
                  <ul>
                    {Object.keys(flagConfig).map(
                      key =>
                        key !== locale.lang && (
                          <li key={key}>
                            <LocaleFlag
                              changeLocale={this._changeLocale}
                              lang={flagConfig[key].langCode}
                              flag={flagConfig[key].flagCode}
                              langName={flagConfig[key].langName}
                              selectedLocale={
                                locale.lang === flagConfig[key].langCode
                              }
                            />
                          </li>
                        )
                    )}
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

Navigation.propTypes = propTypes;

export default injectIntl(Navigation);
